import waitForElement from "utils/waitForElement";

// Following the design mobile metrics
const MD_SCREEN_WIDTH = 834;

/**
 * According to the Intercom documentation, the mobile devices do not support custom attributes
 * (vertical_padding, horizontal_padding)
 * https://developers.intercom.com/installing-intercom/web/attributes-objects#messenger-attributes
 *
 * This is a workaround to apply custom styles to the intercom button
 */
const customStylesForMobile = async ({
  verticalPadding,
  horizontalPadding,
}: {
  verticalPadding: number;
  horizontalPadding: number;
}) => {
  // Verify if device is mobile
  if (window.innerWidth > MD_SCREEN_WIDTH) {
    return;
  }

  const intercomButton = (await waitForElement(
    ".intercom-lightweight-app-launcher"
  )) as HTMLElement;

  if (intercomButton) {
    intercomButton.style.bottom = verticalPadding + "px";
    intercomButton.style.right = horizontalPadding + "px";
  }
};

export default customStylesForMobile;
